import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import Images from 'assets/images/imageData';
import Regex from 'services/utils/regex/Regex';

const replyInputs = {
  ticketId: '',
  leadSiteId: '',
  responseText: '',
  document: '',
};

const ReplyForm = ({
  ticketId,
  replySubmit,
  documentUploadUrl,
  documentUrlData,
}) => {
  const [replyData, setReplyData] = useState(replyInputs);
  const [className, setClassName] = useState('empty');

  useEffect(() => {
    setReplyData({
      ...replyData,
      ticketId: ticketId,
    });
  }, [ticketId]);

  const onBlur = () => {
    if (replyData.responseText) setClassName('');
    else setClassName('empty');
  };

  return (
    <form
      className="reply-ticket-form"
      onSubmit={(e) => {
        e.preventDefault();
        replySubmit(replyData);
      }}
    >
      <TextAreaInput
        type="text"
        rows={3}
        label={localization.enterReplyDescription}
        className={`${className} inline-css scrollbar-styling`}
        regex={Regex.text.test(replyData.responseText)}
        value={replyData?.responseText}
        inputValue={replyData?.responseText}
        onBlur={onBlur}
        errorMsg={localization.isRequired}
        required
        isStarRequired={true}
        handleChange={(e) => {
          setReplyData({
            ...replyData,
            responseText: e.target.value,
          });
        }}
      />
      <div className="form-group form-btn">
        <div className="custom-upload pr-15">
          <FileUpload
            id="addReplyAttachment"
            multiple="multiple"
            accept=".pdf,.png,.jpg,.jpeg,.doc"
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            onChange={(val) =>
              setReplyData({
                ...replyData,
                document: val,
              })
            }
          >
            <span className="btn btn-transparent">
              {localization.uploadMultiAttachment}
            </span>
          </FileUpload>
        </div>
        <div className="custom-upload">
          <button type="submit" className="btn btn-primary">
            {localization.reply} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default ReplyForm;
